import { cn } from '@/lib/utils'
import { HTMLProps } from 'react'

interface TitleProps extends HTMLProps<HTMLSpanElement> {
    children?: React.ReactNode
    BoxProps?: HTMLProps<HTMLDivElement>
}

export type { TitleProps as DialogTitleProps }

export function Title({ children, BoxProps, ...props }: TitleProps) {
    return (
        <span
            id="scroll-dialog-title"
            {...props}
            className={cn(
                'overflow-y-hidden overflow-x-auto',
                'p-5 text-lg font-medium',
                props.className,
            )}
        >
            <div
                {...BoxProps}
                className={cn(
                    'flex flex-row flex-nowrap',
                    'px-2 sm:px-4 justify-between items-center',
                    'min-w-max gap-8',
                    BoxProps?.className,
                )}
            >
                {children}
            </div>
        </span>
    )
}
